module.exports = __webpack_public_path__ + "img/DS223j.70f8015f.png";